module.exports = __webpack_public_path__ + "static/media/Q2_figure.ca51350b.png";